
    <p>
      <a routerLink="/root/protected" href>Secure Area</a><span *ngIf="loggedIn"> | </span>
      <a href (click)="signout()" *ngIf="loggedIn">Sign Out</a>
    </p>
  